module.exports = __webpack_public_path__ + "static/media/morko.f7bad378.jpeg";